import {
  Box,
  Grid,
  Button,
  IconButton,
  Modal,
  Fade,
  Divider,
  FormControl,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  GetRoles,
  UpdateAndSaveUser,
  GetUsers,
} from "../centralAdminSlice";
import MultiSelectCountry from "./MultiSelectCountry_updated";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Alert from "../../../components/ui/Alert";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};

export default function EditUser(props) {
  const params = props.params;

  const [validate, setValidate] = useState({
    firstnameValidated: true,
    lastnameValidated: true,
  });

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const { countries, roles } = centralAdmin;

  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, []);

  useEffect(() => {
    if (roles.length <= 0) {
      dispatch(GetRoles({ method: "Get" }));
    }
  }, []);

  const UpdateUser = () => {
    let geoIdArray = [];
    let filteredGeoIdArray = [];

    if (updatedGeoNameList == "") {
      filteredGeoIdArray = params.params.row.geoID;

      if (filteredGeoIdArray.length == 0) {
        filteredGeoIdArray = countries.map((item) => item.countryID);
      }
    } else {
      geoIdArray = countries.map((item) =>
        updatedGeoNameList.includes(item.countryName) ? item.countryID : null
      );

      filteredGeoIdArray = geoIdArray.filter((item) => item !== null);
      if (filteredGeoIdArray == "" || filteredGeoIdArray == []) {
        filteredGeoIdArray = countries.map((item) => item.countryID);
      }
    }

    const postData = [
      {
        userID: params.params.row.userID,
        firstName: firstName,
        lastName: lastName,
        email: email,
        roleID: role,
        geoID: filteredGeoIdArray.toString(),
        activeFlag: isActive == "Active" ? "Y" : "N",
        notifyByEmailFlag: notifyByEmail == "Yes" ? true : false,
        restrictedAccess: isRestrictedAccess ? 1 : 0,
        isInsert: "FullUpdate",
      },
    ];

    if (!validate.firstnameValidated)
      displayAlert(true, "Please enter First Name");
    else if (!validate.lastnameValidated)
      displayAlert(true, "Please enter Last Name");
    else {
      dispatch(UpdateAndSaveUser(postData)).then(()=>{
        handleClose();
        props.handleDisplay();
      });
    }
  };

  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  useEffect(() => {
    //Check if any of the dropdown are false and then set alertDisplay to false
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...Alert, alertDisplay: false });
    }
  }, [validate]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [firstName, setFirstName] = useState(params.params.row.firstName);
  const [lastName, setLastName] = useState(params.params.row.lastName);
  const [email, setEmail] = useState(params.params.row.email);
  const [role, setRole] = useState(params.params.row.roleID);
  const [notifyByEmail, setNotifyByEmail] = useState(
    params.params.row.notifyByEmailFlag
  );
  const [isActive, setIsActive] = useState(params.params.row.activeFlag);
  const [isRestrictedAccess, setIsRestrictedAccess] = useState(
    params.params.row.restrictedAccess
  );

  const [geoIdList, setGeoIdList] = useState(params.params.row.geoID);

  const [updatedGeoNameList, setUpdatedGeoNameList] = useState("");

  if (isActive == "N") {
    setIsActive("InActive");
  } else if (isActive == "Y" && params.params.row.isFirstTimeUser == false) {
    setIsActive("Active");
  } else if (isActive == "Y" && params.params.row.isFirstTimeUser == true) {
    setIsActive("FirstTime");
  }

  if (notifyByEmail == true) {
    setNotifyByEmail("Yes");
  } else if (notifyByEmail == false) {
    setNotifyByEmail("No");
  }

  const handleSelect = (event) => {
    setRole(event.target.value);
  };

  function handleCountrySelection(data) {
    setUpdatedGeoNameList(data);
  }

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
    if (!event.target.value) {
      setValidate({
        ...validate,
        firstnameValidated: false,
      });
    } else {
      setValidate({
        ...validate,
        firstnameValidated: true,
      });
    }
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
    if (!event.target.value) {
      setValidate({
        ...validate,
        lastnameValidated: false,
      });
    } else {
      setValidate({
        ...validate,
        lastnameValidated: true,
      });
    }
  };

  const handleEditIconPress = (event) => {
    setFirstName(params.params.row.firstName);
    setLastName(params.params.row.lastName);
    setEmail(params.params.row.email);
    setRole(params.params.row.roleID);
    setNotifyByEmail(params.params.row.notifyByEmailFlag);
    setIsActive(params.params.row.activeFlag);
    setIsRestrictedAccess(params.params.row.restrictedAccess);

    setValidate({
      firstnameValidated: true,
      lastnameValidated: true,
    });

    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: "",
    });

    setUpdatedGeoNameList("");
    setGeoIdList(params.params.row.geoID);
    handleOpen();
  };

  return (
    <div>
      <IconButton onClick={handleEditIconPress}>
        <EditIcon />
      </IconButton>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style}>
            <h3>Edit User</h3>
            <Divider />
            {alert.alertDisplay && (
              <Alert
                message={alert.alertMessage}
                severity={alert.alertSeverity}
              />
            )}
            <div>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl id="left-control-group">
                    <label>
                      First Name
                      <TextField
                        variant="outlined"
                        value={firstName}
                        onChange={handleFirstNameChange}
                        fullWidth
                        size="small"
                      ></TextField>
                    </label>
                    <label>
                      Email
                      <TextField
                        variant="outlined"
                        disabled={true}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        size="small"
                      ></TextField>
                    </label>
                    <label>
                      QMS Role
                      <TextField
                        variant="outlined"
                        select={roles.length > 0 ? true : false}
                        value={roles.length > 0 ? role : ""}
                        onChange={handleSelect}
                        fullWidth
                        size="small"
                      >
                        {roles.length > 0
                          ? roles.map((role, index) => {
                              return (
                                <MenuItem key={role.roleID} value={role.roleID}>
                                  {role.roleName}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </label>
                    <FormLabel id="row-radio-button-id">
                      Notify By Email
                    </FormLabel>
                    <RadioGroup
                      id="row-radio-buttons"
                      row
                      area-labelledby="row-radio-buttons"
                      name="row-radio-buttons-group"
                      defaultValue={notifyByEmail}
                      onChange={(e) => setNotifyByEmail(e.target.value)}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <label>
                    Country
                    <MultiSelectCountry
                      geoIdList={geoIdList}
                      countryList={countries}
                      sendDataToParent={handleCountrySelection}
                      isEdit={true}
                    ></MultiSelectCountry>
                  </label>
                </Grid>
                <Grid item xs={6}>
                  <FormControl id="right-control-group">
                    <label>
                      Last Name
                      <TextField
                        variant="outlined"
                        value={lastName}
                        onChange={handleLastNameChange}
                        fullWidth
                        size="small"
                      ></TextField>
                    </label>
                    <FormLabel id="column-radio-button-id">
                      In Active Flag
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="column-radio-buttons"
                      id="column-radio-buttons"
                      name="column-radio-buttons"
                      defaultValue={isActive}
                      onChange={(e) => setIsActive(e.target.value)}
                    >
                      <FormControlLabel
                        value="Active"
                        control={<Radio size="small" />}
                        label="Active"
                      />
                      <FormControlLabel
                        value="InActive"
                        control={<Radio size="small" />}
                        label="InActive"
                      />
                      <FormControlLabel
                        value="First Time User"
                        control={<Radio size="small" />}
                        label="FirstTime"
                      />
                    </RadioGroup>
                    <Box mt={2}></Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRestrictedAccess}
                          onChange={(e) =>
                            setIsRestrictedAccess(e.target.checked)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                      label="Restricted Access"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </div>
            <Divider />
            <div style={{ padding: "10px" }}>
              <Button variant="contained" onClick={UpdateUser} size="large">
                Update
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
